import axios from 'axios'
import Ls from './ls'
import store from '../store/index'
import router from '../router/index'
import i18n from '../plugins/i18n'

const landlordAxios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
})

landlordAxios.interceptors.request.use(function (config) {
    const token = Ls.get('landlord.token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    config.headers['X-localization'] = i18n.global.locale
    return config
}, function (error) {
    return Promise.reject(error)
})

landlordAxios.interceptors.response.use(undefined, function (err) {
    if (!err.response) {
        window.toastr.error('Network error: Please check your internet connection')
    } else if (err.response.status === 401) {
        store.dispatch('landlordAuth/logout', true)
    } else if (err.response.status === 403) {
        window.toastr.error(err.response.data.message || 'Access denied')
    } else if (err.response.status === 422) {
        if (typeof err.response.data.message === 'object') {
            window.toastr.error(Object.values(err.response.data.message).join(', '))
        } else {
            window.toastr.error(err.response.data.message || 'Validation error')
        }
    } else {
        window.toastr.error(err.response.data.message || 'Unknown error occurred')
    }
    return Promise.reject(err)
})

export default landlordAxios
